export default "__VITE_ASSET__BJIWpJDF__"